/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useRef, useEffect, useLayoutEffect } from 'react'
import './style.css'
import { CBLocalNavigation } from '@cb/apricot'
import { applicantIdState, searchBarFocusState, apContextState } from '@landscape/ui-lib'
import { useRecoilState, useRecoilValue } from 'recoil'
import { Input } from '@cb/apricot-react'
import { isEmpty } from 'lodash'
import { NavItem } from './NavItem'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import { selectUserRid } from '@landscape/ui-redux'
import { useInput } from 'hooks/useInputHook'
import { useSelector } from 'react-redux'

const NavBars = (props: any) => {
  const [applicantId, setApplicantId] = useRecoilState(applicantIdState)
  const [searchBarFocus, setSearchBarFocus] = useRecoilState(searchBarFocusState)
  const apContextFlag = useRecoilValue(apContextState)
  const rid = useSelector(selectUserRid)
  const history = useHistory()
  const location = useLocation()
  // applicant id from input field
  const { value, bind } = useInput('')
  const localNavRef = useRef(null)
  const inputElem = document.getElementById('applicant-id-search')
  const inputRef = useRef(inputElem)

  useEffect(() => {
    if (localNavRef.current) {
      CBLocalNavigation({
        elem: localNavRef.current,
        sticky: true,
      })
    }
  }, [])

  const isLinkActive = (path: string) => {
    if (path === '/chart') {
      return location.pathname.startsWith(path)
    }

    return location.pathname === path
  }

  useLayoutEffect(() => {
    if (searchBarFocus && !applicantId) {
      inputRef.current!.focus()
    }
  })

  const handleSubmit = (evt: any) => {
    evt.preventDefault()
    if (!isEmpty(value && value.trim()) && value.trim() !== applicantId) {
      setApplicantId(value)
    }

    if (!isLinkActive('/chart')) {
      history.push(`/chart/${value}`)
      setSearchBarFocus(false)
    } else {
      applicantId !== value && history.push(`/chart/${value}`)
      setSearchBarFocus(false)
    }
  }

  return (
    <div className="cb-local-navigation cb-white-bg cb-box-shadow-bottom" ref={localNavRef}>
      {/* Desktop nav */}
      <div className="cb-desktop-navigation container">
        <div className="row">
          <nav className="col-xs cb-nav-container" aria-label="Landscape Local Navigation">
            <div className="cb-site-name">
              <form className="nav-applicant-search" onSubmit={handleSubmit}>
                <Input
                  id="applicant-id-search"
                  data-testid="applicant-id-input"
                  clearable
                  floating
                  icon="search"
                  label="Applicant ID"
                  iconRight="true"
                  {...bind}
                  value={value}
                  ref={inputRef}
                />
              </form>
            </div>
            <div className="cb-nav-items hidden-xs-only" role="navigation">
              <nav
                className="cb-menu-list cb-menu-list-horizontal cb-no-wrap"
                aria-label="Landscape Menu"
              >
                <ul>
                  <li className="cb-nav-link cb-procedural" key="home" data-testid="nav-home">
                    <NavLink
                      className={`cb-menu-link ${isLinkActive('/') ? 'cb-selected' : ''}`}
                      to="/"
                      exact
                    >
                      <NavItem glyph="cb-home" navText="Home" />
                    </NavLink>
                  </li>
                  {rid === '810' && (
                    <li className="cb-nav-link cb-procedural" key="jobs" data-testid="nav-jobs">
                      <NavLink
                        className={`cb-menu-link ${isLinkActive('/jobs') ? 'cb-selected' : ''}`}
                        to="/jobs"
                      >
                        <NavItem glyph="cb-task-complete" navText="Jobs" />
                      </NavLink>
                    </li>
                  )}
                  <li className="cb-nav-link cb-procedural" key="chart" data-testid="nav-chart">
                    <NavLink
                      className={`cb-menu-link ${isLinkActive('/chart') ? 'cb-selected' : ''}`}
                      to="/chart"
                    >
                      <NavItem glyph="cb-barchart" navText="Chart" />
                    </NavLink>
                  </li>
                  {(import.meta.env.VITE_NODE_ENV == 'development' || apContextFlag) && (
                    <li
                      className="cb-nav-link cb-procedural"
                      key="apchart"
                      data-testid="nav-apchart"
                    >
                      <NavLink
                        className={`cb-menu-link ${isLinkActive('/apchart') ? 'cb-selected' : ''}`}
                        to="/apchart"
                      >
                        <NavItem glyph="cb-barchart" navText="AP Context Dashboard" />
                      </NavLink>
                    </li>
                  )}

                  {rid === '810' && (
                    <>
                      <li className="cb-nav-link" data-testid="nav-reports">
                        <div className="cb-dropdown" id="report">
                          <a
                            className="cb-dropdown-toggle"
                            href="#"
                            role="button"
                            aria-expanded="false"
                          >
                            <span>Reports</span>
                            <i className="cb-glyph cb-down" aria-hidden="true"></i>
                            <i className="cb-glyph cb-up cb-hidden" aria-hidden="true"></i>
                          </a>
                          {/* menu items */}
                          {/* "cb-menu-right-always" makes sure the dropdown menu is right aligned and in browsers viewport */}
                          <div className="cb-dropdown-menu cb-menu-right-always cb-box-shadow">
                            <ul aria-labelledby="...">
                              {/* specify second level of navigation */}
                              <li className="cb-nav-link-second" data-testid="nav-aggregate-files">
                                <NavLink
                                  className={`cb-menu-link ${
                                    isLinkActive('/agg-reports') ? 'cb-selected' : ''
                                  }`}
                                  to="/agg-reports"
                                >
                                  <NavItem glyph="cb-note" navText="Aggregate Files" />
                                </NavLink>
                              </li>
                              <li
                                className="cb-nav-link-second"
                                data-testid="nav-institution-reports"
                              >
                                <NavLink
                                  className={`cb-menu-link ${
                                    isLinkActive('/institution-reports') ? 'cb-selected' : ''
                                  }`}
                                  to="/institution-reports"
                                >
                                  <NavItem glyph="cb-note" navText="Institution Reports" />
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </>
                  )}
                  <li className="cb-nav-link cb-procedural" key="help" data-testid="nav-help">
                    <NavLink
                      className={`cb-menu-link ${isLinkActive('/help') ? 'cb-selected' : ''}`}
                      to="/help"
                    >
                      <NavItem glyph="cb-question" navText="Help" />
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
            {/* End Desktop Nav Menu Items */}
            {/* Mobile Trigger */}
            <div className="cb-mobile-trigger hidden-sm-up">
              <a
                href="#"
                className="cb-glyph cb-menu cb-no-text-decoration cb-link-black"
                aria-expanded="false"
                tabIndex={0}
                aria-hidden="true"
              >
                <span className="sr-only">Landscape Navigation</span>
              </a>
            </div>
          </nav>
        </div>
      </div>
      {/* End Desktop Nav */}
      {/* container for mobile panels */}
      <div className="cb-mobile-navigation"></div>
    </div>
  )
}

export { NavBars, applicantIdState, searchBarFocusState }
